module.exports = __webpack_public_path__ + "img/logo.376fe171.svg";